module.exports = __webpack_public_path__ + "static/media/no_product_cover.ef9f6675.png";